export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Roman.46051620.ttf";